module.exports = "/images/order.svg?cf5cfd63a9813b7dcc402502f70286b1";